


import React, { useEffect, useState } from 'react'
import Loading from '../../Components/shared/Loading/Loading'
import { API_URL_LOCALE_BASE } from '../../configuration/config';
import axios from 'axios';
import Swal from 'sweetalert2'
import { getListGraficoFiltro } from '../../services/service';
const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
  })
const ActualizarGraficoFiltro = () => {

    const [isLoading, setisLoading] = useState(false)
    const [file, setFile] = useState('');
    const [filePicked, setFilePicked] = useState(false);
    const [listGraph, setListGraph] = useState([]);
    const [valueFilter, setValueFilter] = useState();



    const HandleChange = (e:any) => {
        setFile(e.target.files[0]);
        setFilePicked(true);
    }
    const HandleSubmit = (event:any) => {
        event.preventDefault();
        setisLoading(true)
        if(filePicked ){
            const typeData = {
                headers: {
                    "content-type": "multipart/form-data",
                    'Authorization' : "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjE2NTg5NTY3NzAsImlhdCI6MTY1ODk1NjcxMCwiaXNzIjoia2VuIiwiZGF0YSI6eyJpZCI6MSwibG9naW5fdGltZSI6MTY1ODk1NjcxMH19.45uOgB5kJN6b171vgpOxKILot0_QM9LdYVI119SNdRc"
                }
            };
            const formData = new FormData();
            formData.append('file_excel', file);
            //@ts-ignore
            formData.append('id_graph', valueFilter);

            axios.post( API_URL_LOCALE_BASE + 'actualizar-grafico-filtro', formData, typeData).then( async (response:any) =>{
                let {data} = response;
                if(parseInt(data.status) === 200){
                    Toast.fire({
                        icon: 'success'
                        ,title: 'Archivo Excel Ingresado con Exito!'
                    });
                } else {
                    Toast.fire({
                        icon: "error"
                        ,title: "Error: Status " + data.status
                    });
                }
                setisLoading(false);
            });
        } else {
            setisLoading(false);
            Toast.fire({
                icon: "error"
                ,title: "Valide los Datos a Ingresar"
            });
        }
    }

    useEffect(() => {
        getListGraficoFiltro().then((r:any) => {

            console.log('====================================');
            console.log('Listado graficos', r.data.data);
            setListGraph(r.data.data)
            console.log('====================================');
        })

    }, [])
    
  return (

        <>
            {isLoading ? <Loading loading={isLoading} /> : null}
            <div className="card m-2 mt-4">
                <div className="card-header">
                    <h1>Actualizar Grafico Filtro</h1>
                </div>
                <div className="card-body">
                    <form>
                    <div className="mb-3">
                    <select id="tipoGrafico" name="tipoGrafico" className="form-select" defaultValue="0" onChange={(e:any) => {
                            console.log('====================================');
                            console.log(e.target.value);
                            console.log('====================================');
                        setValueFilter(e.target.value);
                    }}>
                            <option value="0">Seleccione un tipo de grafico</option>
                            {listGraph.map((item:any) => {
                                return (
                                    <option value={item.id} key={item.id}>{item.nombre}</option>
                                )
                            })}
                        </select>
                        </div>
                        <div className="mb-3 ">
                            <label className="form-label">Seleccione el arhcivo excel que desea cargar</label>
                            <input className="form-control" type="file" id="excel" name="excel" onChange={HandleChange}/>
                        </div>
                        <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                            <button type="submit" className="btn btn-primary" onClick={HandleSubmit}>Subir Excel</button>
                        </div>
                    </form>
                </div>
                <div className="card-footer">
                    
                </div>
            </div>
        </>
    )
}
export default  ActualizarGraficoFiltro;